(function(){
  var KEY='se_theme_mode';
  var root=document.documentElement;
  var loyaltyObserver=null;
  var loyaltyInitTimer=0;
  var loyaltyEventsBound=false;
  var loyaltyEvents=[
    'frcp.loyalty.mounted',
    'frcp.loyalty.walletMounted',
    'frcp.loyalty.earningRulesMounted',
    'frcp.loyalty.spendingRulesMounted',
    'frcp.loyalty.activitiesMounted',
    'frcp.loyalty.modalMounted',
    'frcp.loyalty.widgetScriptLoaded',
    'frcp.loyalty.launcherMounted'
  ];

  function getStored(){try{return localStorage.getItem(KEY);}catch(e){return null;}}
  function setStored(v){try{localStorage.setItem(KEY,v);}catch(e){}}

  function apply(theme){
    if(theme!=='dark'&&theme!=='light') theme='light';
    root.dataset.theme=theme;
    setStored(theme);
  }

  /* SE - Grid nodes - 18 Mar '26' */
  function getLoyaltyNodes(scope){
    var container=scope&&scope.querySelectorAll?scope:document;
    var nodes=[];

    if(container!==document&&container.matches&&container.matches('.frcp-loyalty-grid-points[data-price]')){
      nodes.push(container);
    }

    nodes=nodes.concat(Array.prototype.slice.call(container.querySelectorAll('.frcp-loyalty-grid-points[data-price]')));
    return nodes;
  }

  /* SE - Drawer nodes - 18 Mar '26' */
  function getLoyaltyBalanceNodes(scope){
    var container=scope&&scope.querySelectorAll?scope:document;
    var nodes=[];

    if(container!==document&&container.matches&&container.matches('[data-loyalty-balance]')){
      nodes.push(container);
    }

    nodes=nodes.concat(Array.prototype.slice.call(container.querySelectorAll('[data-loyalty-balance]')));
    return nodes;
  }

  /* SE - Wishlist tabindex normalization - 14 May '26' */
  function getWishlistButtons(scope){
    var container=scope&&scope.querySelectorAll?scope:document;
    var nodes=[];

    if(container!==document&&container.matches&&container.matches('.frcp-wishlist-btn[tabindex]')){
      nodes.push(container);
    }

    nodes=nodes.concat(Array.prototype.slice.call(container.querySelectorAll('.frcp-wishlist-btn[tabindex]')));
    return nodes;
  }

  function normalizeWishlistTabindex(scope){
    var nodes=getWishlistButtons(scope);
    if(!nodes.length) return;

    nodes.forEach(function(node){
      var tabindex=parseInt(node.getAttribute('tabindex')||'',10);
      if(!isNaN(tabindex)&&tabindex>0){
        node.setAttribute('tabindex','0');
      }
    });
  }

  /* SE - Grid points - 18 Mar '26' */
  function initGridLoyaltyPoints(scope){
    var loyalty=window.frcp&&window.frcp.loyalty;
    var nodes=getLoyaltyNodes(scope);

    if(!nodes.length) return true;
    if(!loyalty||typeof loyalty.updatePointsPreview!=='function') return false;

    nodes.forEach(function(node){
      var price=parseInt(node.getAttribute('data-price')||'',10);
      if(!price) return;

      loyalty.updatePointsPreview(node,price);

      if(!node.__hcLoyaltyBound&&typeof loyalty.toggleLoyaltyWidget==='function'){
        node.addEventListener('click',loyalty.toggleLoyaltyWidget);
        node.__hcLoyaltyBound=true;
      }
    });

    return true;
  }

  /* SE - Drawer balance - 18 Mar '26' */
  function initLoyaltyBalance(scope){
    var loyalty=window.frcp&&window.frcp.loyalty;
    var nodes=getLoyaltyBalanceNodes(scope);
    var customer=loyalty&&loyalty.customer&&loyalty.customer.data;
    var storeCredit=loyalty&&loyalty.customer&&loyalty.customer.storeCredit;

    if(!nodes.length) return true;

    function getCurrencyFractionDigits(currency,locale){
      if(!currency) return 0;

      try{
        return new Intl.NumberFormat(locale,{
          style:'currency',
          currency:currency
        }).resolvedOptions().maximumFractionDigits;
      }catch(e){
        return 2;
      }
    }

    function normalizeAmount(amount,currency){
      var locale=(document.documentElement&&document.documentElement.lang)||undefined;
      var number=Number(amount);
      var fractionDigits=getCurrencyFractionDigits(currency,locale);

      if(amount==null||amount==='') return amount;
      if(isNaN(number)) return amount;
      if(!fractionDigits) return number;

      return number/Math.pow(10,fractionDigits);
    }

    function formatAmount(amount,currency){
      var locale=(document.documentElement&&document.documentElement.lang)||undefined;
      var number=Number(normalizeAmount(amount,currency));

      if(amount==null||amount==='') return '';
      if(isNaN(number)) return String(amount);
      if(!currency) return number.toLocaleString(locale);

      try{
        return new Intl.NumberFormat(locale,{
          style:'currency',
          currency:currency
        }).format(number);
      }catch(e){
        return number.toLocaleString(locale)+' '+currency;
      }
    }

    function renderTemplate(template,values){
      return String(template||'')
        .replace(/__POINTS__/g,values.points)
        .replace(/{{\s*points\s*}}/g,values.points)
        .replace(/__AMOUNT__/g,values.amount)
        .replace(/{{\s*amount\s*}}/g,values.amount);
    }

    var rendered=false;
    nodes.forEach(function(node){
      var isLoggedIn=node.getAttribute('data-customer-logged-in')==='true';
      var points=customer&&customer.points;
      var template=node.getAttribute('data-loyalty-template')||'';
      var templateWithAmount=node.getAttribute('data-loyalty-template-with-amount')||'';
      var amount=storeCredit&&storeCredit.amount;
      var currency=storeCredit&&storeCredit.currency;
      var formattedPoints;
      var formattedAmount;
      var output;
      if((points==null||points==='')&&isLoggedIn){
        points=0;
      }
      if((points==null||points==='')&&(amount!=null&&amount!=='')){
        points=0;
      }
      if((points==null||points==='')&&(amount==null||amount==='')){
        points=0;
      }
      rendered=true;
      formattedPoints=Number(points).toLocaleString();
      formattedAmount=formatAmount(amount,currency);
      output=formattedAmount&&templateWithAmount
        ? renderTemplate(templateWithAmount,{points:formattedPoints,amount:formattedAmount})
        : renderTemplate(template,{points:formattedPoints,amount:formattedAmount});
      node.textContent=output||formattedPoints;

      if(!node.__hcLoyaltyBound&&typeof loyalty.toggleLoyaltyWidget==='function'){
        node.addEventListener('click',loyalty.toggleLoyaltyWidget);
        node.__hcLoyaltyBound=true;
      }
    });

    return rendered;
  }

  /* SE - Loyalty retry - 18 Mar '26' */
  function queueGridLoyaltyPointsInit(scope,attempt){
    var tries=typeof attempt==='number'?attempt:0;
    if(loyaltyInitTimer) clearTimeout(loyaltyInitTimer);

    loyaltyInitTimer=window.setTimeout(function(){
      var initialized=initGridLoyaltyPoints(scope);
      var balanceInitialized=initLoyaltyBalance(scope);
      initialized=initialized&&balanceInitialized;
      if(!initialized&&tries<60) queueGridLoyaltyPointsInit(scope,tries+1);
    },tries===0?0:250);
  }

  /* SE - Loyalty observer - 18 Mar '26' */
  function observeGridLoyaltyPoints(){
    if(loyaltyObserver||typeof MutationObserver!=='function'||!document.body) return;

    loyaltyObserver=new MutationObserver(function(mutations){
      for(var i=0;i<mutations.length;i++){
        var mutation=mutations[i];
        for(var j=0;j<mutation.addedNodes.length;j++){
          var node=mutation.addedNodes[j];
          if(!node||node.nodeType!==1) continue;
          if(
            (node.matches&&node.matches('.frcp-loyalty-grid-points[data-price], [data-loyalty-balance], .frcp-wishlist-btn[tabindex]'))||
            (node.querySelector&&node.querySelector('.frcp-loyalty-grid-points[data-price], [data-loyalty-balance], .frcp-wishlist-btn[tabindex]'))
          ){
            queueGridLoyaltyPointsInit(node);
            normalizeWishlistTabindex(node);
            return;
          }
        }
      }
    });

    loyaltyObserver.observe(document.body,{childList:true,subtree:true});
  }

  /* SE - Loyalty events - 18 Mar '26' */
  function bindLoyaltyEvents(){
    if(loyaltyEventsBound) return;
    loyaltyEventsBound=true;

    function handleLoyaltyEvent(){
      queueGridLoyaltyPointsInit(document);
    }

    loyaltyEvents.forEach(function(eventName){
      document.addEventListener(eventName,handleLoyaltyEvent);
      if(window&&window.addEventListener) window.addEventListener(eventName,handleLoyaltyEvent);
    });
  }

  function init(){
    var stored=getStored();
    if(stored==='dark'||stored==='light') apply(stored);
    else{
      var prefersDark=false;
      try{prefersDark=window.matchMedia&&window.matchMedia('(prefers-color-scheme: dark)').matches;}catch(e){}
      apply(prefersDark?'dark':'light');
    }

    document.addEventListener('click',function(e){
      var btn=e.target&&e.target.closest?e.target.closest('[data-se-theme-toggle] [data-se-theme]'):null;
      if(!btn) return;
      e.preventDefault();
      apply(btn.getAttribute('data-se-theme'));
    },{passive:false});

    window.hcInitGridLoyaltyPoints=initGridLoyaltyPoints;
    window.hcQueueGridLoyaltyPointsInit=queueGridLoyaltyPointsInit;

    document.addEventListener('collection:reloaded',function(e){
      queueGridLoyaltyPointsInit(e&&e.target?e.target:document);
    });

    document.addEventListener('cart:updated',function(){
      queueGridLoyaltyPointsInit(document);
    });

    /* SE - Loyalty init - 18 Mar '26' */
    bindLoyaltyEvents();
    queueGridLoyaltyPointsInit(document);
    normalizeWishlistTabindex(document);
    observeGridLoyaltyPoints();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
